import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import {
  FontFamily, FontSize,
} from '@powdr/constants';
import { ContentBlockType } from '@powdr/model';
import { getFontStyles } from '@powdr/utils';

// styled components
const ContentBlockQuote = styled.div`
  display: flex;
  gap: 15px;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

const ContentContainer = styled.div`
  text-align: center;
  
  .cb-title {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG30, undefined, undefined)};
    line-height: normal;
  }

  .cb-title, .cb-copy {
    max-width: 100%;
  }
`;

export const Quote = ({
  title, copy, blockType,
  colorProfile, inert,
}) => (
  <ContentBlockQuote
    colorProfile={colorProfile}
    className={`content-block-${blockType}`}
    inert={inert}
  >
    <ContentContainer>
      {(copy) && <h3 className="cb-title">{copy}</h3>}
      {(title) && <p className="cb-copy">{title}</p>}
    </ContentContainer>
  </ContentBlockQuote>
);

Quote.propTypes = PropTypes.objectOf(ContentBlockType).isRequired;
